<template>
  <!--
    全站统一删除确认弹窗（居中）
    ------------------------------------------------------------------
    统一标准：与「会议室订单删除」同一版本，全站所有删除提醒都走这个组件。
    用法：
      <ConfirmDialog v-model="show"
        :desc="'确定要删除「' + name + '」吗？删除后不可恢复。'"
        :loading="deleting" loading-text="删除中"
        @confirm="doDelete" />

    文案模板：标题固定「确认删除」，说明 = 确定要删除…吗？删除后不可恢复。
    props:
      value        显示 / 隐藏（v-model）
      desc         说明文字（纯文本，名称请自行拼进字符串）
      loading      确认按钮 loading（删除中）
      loadingText  删除中按钮文案
      confirmText  确认按钮文案，默认「删除」
      cancelText   取消按钮文案，默认「取消」
    事件：confirm（用户点了确认按钮）
  -->
  <van-popup
    :value="value"
    round
    :close-on-click-overlay="false"
    :style="{ width: '82%', maxWidth: '300px' }"
    class="confirm-dialog"
  >
    <div class="confirm-dialog__hd">
      <div class="confirm-dialog__title">{{ title }}</div>
      <div class="confirm-dialog__desc">{{ desc }}</div>
    </div>
    <div class="confirm-dialog__bd">
      <button
        type="button"
        class="confirm-dialog__btn confirm-dialog__btn--cancel"
        :disabled="loading"
        @click="onCancel"
      >{{ cancelText }}</button>
      <button
        type="button"
        class="confirm-dialog__btn confirm-dialog__btn--danger"
        :disabled="loading"
        @click="onConfirm"
      >{{ loading ? loadingText : confirmText }}</button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "确认删除" },
    desc: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: "删除中" },
    confirmText: { type: String, default: "删除" },
    cancelText: { type: String, default: "取消" }
  },
  methods: {
    onCancel() {
      if (this.loading) return;
      this.$emit("input", false);
      this.$emit("cancel");
    },
    onConfirm() {
      if (this.loading) return;
      this.$emit("confirm");
    }
  }
};
</script>

<style>
/* 全站唯一：删除确认弹窗样式。改这里 = 改全站。 */
.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(15, 25, 50, 0.22);
}
.confirm-dialog__hd {
  padding: 20px 18px 0;
  text-align: center;
}
.confirm-dialog__title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2329;
  line-height: 1.4;
}
.confirm-dialog__desc {
  margin-top: 10px;
  font-size: 13px;
  color: #646a73;
  line-height: 1.65;
  word-break: break-all;
}
.confirm-dialog__bd {
  display: flex;
  gap: 10px;
  padding: 16px;
}
.confirm-dialog__btn {
  flex: 1;
  height: 40px;
  border: 0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
  -webkit-tap-highlight-color: transparent;
}
.confirm-dialog__btn:active {
  opacity: 0.85;
}
.confirm-dialog__btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.confirm-dialog__btn--cancel {
  background: #eef2fb;
  color: #2b5fd9;
}
.confirm-dialog__btn--danger {
  background: #e2465b;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmDialog.vue